import { EmployeeRejectLeavePageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import RejectLeave from 'modules/timeoff/components/RejectLeave'

import { useOnClose } from './useOnClose'

const RejectLeavePage = () => {
  const { leave_id: leaveId, id } = useStrictParams<'leave_id' | 'id'>()
  const onClose = useOnClose(id)

  const { data } = useQuery(EmployeeRejectLeavePageDocument, {
    variables: {
      leaveId: parseInt(leaveId, 10),
    },
  })

  const leaveEmployee = data?.timeoff.leave?.employee

  if (!leaveEmployee) {
    throw new Error('Leave employee not found')
  }

  return <RejectLeave leaveId={+leaveId} onClose={onClose} leaveEmployeeId={leaveEmployee.id} />
}

export default RejectLeavePage
